import React from 'react'

const React_Coding_Practice_31 = () => {
  return (
    <div>
      <h1>Coding Pratice 31</h1>
    </div>
  )
}

export default React_Coding_Practice_31
